<template>
  <div class="header_fixed">
    <div id="bannerPWA" class="banner-pwa" v-if="showInstallButton">
      <div class="container">
        <div id="installPWA" class="banner-pwa__install" @click="installApp">
          <div class="banner-pwa__icon">
            <img src="@/assets/login_logo.png" >
          </div>
          <div class="banner-pwa__text">{{ $t('table.desktop') }}</div>
        </div>
        <div id="closePWA" class="banner-pwa__close" @click="close">&nbsp;</div>
      </div>
    </div>
    <div class="header container">
      <div class="header_logo"><router-link class="link" :to="{path:'/'}"><img src="../assets/logo.png"></router-link></div>
      <div class="header-nav">
        <ul :class="language=='lk'? 'bur':''">
          <li><router-link class="link" :to="{path:'/howToBorrow'}">{{ $t('route.howToBorrow') }}</router-link></li>
          <li><router-link class="link" :to="{path:'/howToRepay'}">{{ $t('route.howToRepay') }}</router-link></li>
          <li><router-link class="link" :to="{path:'/FAQ'}">{{ $t('route.faq') }}</router-link></li>
          <li><router-link class="link" :to="{path:'/About'}">{{ $t('route.about') }}</router-link></li>
          <li><router-link class="link" :to="{path:'/Contact'}">{{ $t('route.contact') }}</router-link></li>
        </ul>
      </div>
      <div class="header_cabinet">
        <router-link v-if="isLogin" class="link" :to="{path:'/user'}"><img src="../assets/login.svg"> {{$utils.hidePhone(phone)}}</router-link>
        <router-link v-else="isLogin" class="link" :to="{path:'/login'}"><img src="../assets/login.svg"> {{ $t('table.btnLogin')}}</router-link>
      </div>
      <div class="header_lang">
        <span v-for="(item,index) in languagelist" :key="index" @click="selectlang(item.value)" :class="item.value==language ? 'active':''">{{ item.label }}</span>
      </div>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'app-header',
        data () {
            return {
              language: 'en', // 选中的语言
              languagelist: [{  //语言包
                value: 'en',
                label:'Eng',
              },
                // {
                //   value: 'lk',
                //   label:'සිංහල',
                // }
              ],
              phone: '',
              isLogin:false,
              showInstallButton: false, // 用来判断当前浏览器是否支持安装
              installPromptEvent: null, // 实例对象
            }
        },
      created() {
        // 获取缓存的语种，如若没有（新用户），保存当前默认语言
        if (localStorage.getItem('lang')) {
          this.language = localStorage.getItem('lang')
        } else {
          localStorage.setItem('lang', this.language)
        }
        this.headerCheckLogin()
        window.addEventListener('beforeinstallprompt', event => {
          // 防止默认的应用安装提示
          event.preventDefault();
          // 在Vue组件中保存事件对象
          this.installPromptEvent = event;
          // 显示安装按钮
          this.showInstallButton = true;
        });
      },
      methods: {
        installApp() {
          if (this.installPromptEvent) {
            // 调用安装操作
            this.installPromptEvent.prompt();
          }
        },
        close(){
          this.showInstallButton = false;
        },
        headerCheckLogin(){
          if(localStorage.getItem('token')){
            this.isLogin = true
            this.phone = localStorage.getItem('phone')
          }else{
            this.isLogin = false
          }
        },
        selectlang(e) {
          // 根据监听改变获取到的值去数组里找到对应的值
          localStorage.setItem('lang', e)
          this.$i18n.locale = e //切换字典文件
          this.language = e
          history.go(0);
        },
      }
    }
</script>
